<div class="bg-m0 flex select-none flex-col p-9">
  <div
    data-cy="createFolderDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Create Folder</div
  >

  <form
    class="flex w-[450px] flex-col"
    [formGroup]="createFolderForm"
    (ngSubmit)="create()"
  >
    <input
      #folderName
      autocomplete="off"
      spellcheck="false"
      data-cy="createFolderDialogFolderNameInput"
      class="form-input border-s3 focus:border-m600 mt-9 rounded"
      [ngClass]="{
        'border-r600':
          createFolderForm.controls['folderName'].invalid &&
          createFolderForm.controls['folderName'].touched
      }"
      formControlName="folderName"
      placeholder="Folder Name"
    />
    <m-validation
      [control]="createFolderForm.controls['folderName']"
    ></m-validation>

    <div class="mt-6">
      <button
        data-cy="createFolderDialogCreateButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        type="submit"
        >Create</button
      >

      <button
        data-cy="createFolderDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >
    </div>
  </form>
</div>
